export const CONTENTFUL_API_BASE_URL=process.env.REACT_APP_CONTENTFUL_CDN
export const CONTENTFUL_API_SPACE_ID=process.env.REACT_APP_CONTENTFUL_API_SPACE
export const CONTENTFUL_API_TOKEN=process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN

export const HUBSPOT_FORMS_JS_URL=process.env.REACT_APP_HUBSPOT_FORMS_JS_URL
export const HUBSPOT_PORTAL_ID=process.env.REACT_APP_HUBSPOT_PORTAL_ID
export const HUBSPOT_CONTACT_USE_FORM_ID=process.env.REACT_APP_HUBSPOT_CONTACT_USE_FORM_ID

export const API_URL = process.env.REACT_APP_API_URL;
export const SUPPORT_API_URL = process.env.REACT_APP_SUPPORT_API_URL || 'http://127.0.0.1:8100';
export const TERMS_CONDITIONS_URL = process.env.REACT_APP_TERMS_CONDITIONS_URL;
export const MAZHR_APP_URL = process.env.REACT_APP_MAZHR_APP_URL;

export const IMAGES_BASE_URL = process.env.REACT_APP_IMAGES_URL;

export const COUNTRY_CODE_FINLAND = "FI";
export const COUNTRY_CODE_GERMANY = "DE";

/** Mirrors corporate-api EmployeeCount. Stored as company.employee_count. */
export const EMPLOYEE_COUNT = {
  SIZE_1_49: "1-49",
  SIZE_50_249: "50-249",
  SIZE_250_999: "250-999",
  SIZE_1000_4999: "1000-4999",
  SIZE_5000_PLUS: "5000+",
};
export const EMPLOYEE_COUNT_VALUES = Object.values(EMPLOYEE_COUNT);

export const MAZHR_JWT_KEY = 'mazhr_jwt';
export const MAZHR_USER_DATA_KEY = 'mazhr_user_data_key';

export const MAZHR_REG_DATA = 'mazhr_reg_data'

export const SEARCH_TYPE_SUITABILITY = 'suitability'
export const SEARCH_TYPE_TARGET_POSITION = 'target-position'

// eslint-disable-next-line
export const VALID_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// eslint-disable-next-line
export const OLD_VALID_PASSWORD = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).*$/;
export const OLD_VALID_PASSWORD_INSTRUCTION = "Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (like !, @, #)";
export const VALID_PASSWORD = /^(?=(?:.*[a-z]){2,})(?=(?:.*[A-Z]){2,})(?=(?:.*\d){2,})(?=(?:.*\W){2,}).{8,}$/;
export const VALID_PASSWORD_INSTRUCTION = "Password must be at least 8 characters long and include at least 2 uppercase letters, 2 lowercase letters, 2 numbers, and 2 special characters (like !, @, #)";

export const NO_PASSWORD_DUPLICATION_INSTRUCTION = "New password must be different from current password";

// eslint-disable-next-line
export const VALID_NAME = /^[\p{L}\p{M}\d@$#%^&*()\-+=[\]{};:'",.<>?/~|\\ ]{2,}$/u;

// eslint-disable-next-line
export const VALID_PHONE = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export const EXAMPLE_RECRUITMENT_PROCESS = [
    {
        title: 'Phone interview',
        description: 'Phone call to evaluate a candidate \'s fit for the job'
    },
    {
        title: 'Applicant assessment',
        description: 'Hiring process includes work-related assessments. It takes 15-20min to complete one assessment. Assessments are provided by AON.'
    },
    {
        title: 'Technical interview',
        description: 'Interview to assess your technical ability for the role, and the depth and breadth of your knowledge in your chosen field'
    }
]

export const FAQCATEGORIES = ['faq-service-use', 'faq-analytics']

export const TALENT_SEARCH_FILTER_TEAM_STRENGTHS = "Team Strengths"
export const TALENT_SEARCH_FILTER_SALES_STRENGTHS = "Sales Strengths"
export const TALENT_SEARCH_FILTER_MOTIVATION_FACTORS = "Motivation Factors"
export const TALENT_SEARCH_FILTER_COMPETENCES = "Work Styles"
export const ENTER_KEY = "Enter"

export const USER_FILTER_TYPE_ALL = 2
export const USER_FILTER_TYPE_ONLY_POOLS = 1
export const USER_FILTER_TYPE_ONLY_TEAMS = 0

export const INITIAL_TALENT_SEARCH_FILTER_ARRAY = [
    {"Team Strengths": {}},
    {"Sales Strengths": {}},
    {"Motivation Factors": {}},
    {"Work Styles": {}}
]

//Used on talent search page
export const LOCAL_STORAGE_KEY_SELECTED_MENU = "selected-menu"
export const LOCAL_STORAGE_KEY_SEARCH_TYPE = "search-type"
export const LOCAL_STORAGE_KEY_SELECTED_TARGET_PROFILE = "selected-target-profile"
export const LOCAL_STORAGE_KEY_SELECTED_INDUSTRY = "selected-industry"
export const LOCAL_STORAGE_KEY_SELECTED_CANDIDATE_ID = "selected-candidate-id"
export const LOCAL_STORAGE_KEY_SELECTED_POSITION_ID = "selected-position-id"
export const LOCAL_STORAGE_KEY_USER_ROLE_ID = "user-role-id"

export const URL_WITH_HASH_FOR_TEAM_CHECK = "#internal"

export const DOWNLOAD_OPTIONS_FOR_ALL = "0"

export const TAB_KEY_ANALYTICS_KEY = "0"
export const TAB_BEHAVIOURS_KEY = "1"
export const TAB_COMPETENCIES_KEY = "2"
export const TAB_MOTIVATIONS_KEY = "3"
export const TAB_ADEPT_ASPECTS_KEY = "4";
export const TAB_SALES_STRENGTHS_KEY = "5"
export const TAB_TEAM_STRENGTHS_KEY = "6"

export const ADEPT_STYLES = {
    task: ["Drive", "Structure"],
    adaptation: ["Conceptual", "Flexibility", "Mastery"],
    achievement: ["Ambition", "Power"],
    teamwork: ["Cooperativeness", "Sensitivity", "Humility"],
    emotional: ["Composure", "Positivity", "Awareness"],
    interaction: ["Assertiveness", "Liveliness"]
};

export const ADEPT_ASPECTS = [
    "Drive",
    "Structure",
    "Conceptual",
    "Flexibility",
    "Mastery",
    "Ambition",
    "Power",
    "Assertiveness",
    "Liveliness",
    "Composure",
    "Positivity",
    "Awareness",
    "Cooperativeness",
    "Sensitivity",
    "Humility"
]

// Predefined array of assessments
export const AON_ASSESSMENTS = [
    {
        id: 102,
        label: "Work Personality & Behaviour",
    },
    {
        id: 201,
        label: "Values & Motivation",
    },
    {
        id: 301,
        label: "Numerical Reasoning",
    },
    {
        id: 302,
        label: "Verbal Reasoning",
    },
    {
        id: 344,
        label: "Deductive Reasoning",
    },
    {
        id: 370,
        label: "English",
    },
    {
        id: 390,
        label: "Adept 15 Personality Assessment",
    },
];

export const languageSelectOptions = [
    { code: 1, title: "German" },
    { code: 2, title: "English" },
    { code: 3, title: "French" },
    { code: 4, title: "Italian" },
    { code: 6, title: "Norwegian" },
    { code: 7, title: "Romanian; Moldavian; Moldovan" },
    { code: 8, title: "Dutch; Flemish" },
    { code: 9, title: "Spanish; Castilian" },
    { code: 10, title: "Portuguese" },
    { code: 11, title: "Swedish" },
    { code: 13, title: "Polish" },
    { code: 14, title: "Czech" },
    { code: 15, title: "Russian" },
    { code: 16, title: "Danish" },
    { code: 17, title: "Finnish" },
    { code: 18, title: "Greek" },
    { code: 19, title: "Chinese" },
    { code: 21, title: "Arabic" },
    { code: 29, title: "Slovak" },
];

export const USER_ROLE_OWNER = 1
export const USER_ROLE_ADMIN = 2
export const USER_ROLE_HRD = 3
export const USER_ROLE_MANAGER = 4
export const USER_ROLE_TEAMLEAD = 5
export const USER_ROLE_SPECIALIST = 6

// Administrative roles that can access user management and settings only
export const ADMINISTRATIVE_USER_ROLES = [USER_ROLE_OWNER, USER_ROLE_ADMIN]

// Operational roles that can access main app features to manage the business activities
export const OPERATIONAL_USER_ROLES = [USER_ROLE_HRD, USER_ROLE_MANAGER, USER_ROLE_TEAMLEAD, USER_ROLE_SPECIALIST]

// Companies that have access to Identity and Access Management features
export const IAM_ENABLED_COMPANIES = [1,3,5,55,79,103,133,146,152,154,166,184,194,195]

// Companies that have access to the Credits consumption section in Corporate Settings
export const CREDIT_CONSUMPTION_ENABLED_COMPANIES = [5, 103, 194, 166]

// Demo accounts (corp_user.write_access = false) keep the full UI, but every write is refused by the API
export const NO_WRITE_ACCESS_MESSAGE = "This feature is not available on demo accounts"
export const ERROR_CODE_WRITE_ACCESS_DENIED = 1012

export function getUserRoleStringByRoleId(roleId) {
    switch (roleId) {
        case USER_ROLE_OWNER:
            return "Owner";
        case USER_ROLE_ADMIN:
            return "Admin";
        case USER_ROLE_HRD:
            return "HR Director";
        case USER_ROLE_MANAGER:
            return "HR Manager";
        case USER_ROLE_TEAMLEAD:
            return "Team Lead";
        case USER_ROLE_SPECIALIST:
            return "HR Specialist";
        default:
            return "Unknown"; // Return null for unknown role IDs
    }
}


